import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { PipelineItemClassListQuery } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const QUERY_PIPELINE_ITEM_CLASS_LIST = gql`
    query pipelineItemClassList {
        pipelineItemClassNames {
            nodes {
                className
                description
                typeName
            }
        }
    }
`;

export const queryPipelineItemClassList = async (client: ApolloClient<NormalizedCacheObject>) => {
    
    const { data, errors } = await client.query<PipelineItemClassListQuery>({
        query: QUERY_PIPELINE_ITEM_CLASS_LIST,
    });

    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console.
            console.error(error);
        });
        // Friendly error to the user.
        throw new Error('An error has occurred during the query.');
    }

    return data?.pipelineItemClassNames?.nodes;
};